import { generateCaptchaTokenResult as _generateCaptchaTokenResult } from '@worldcoo/ui/lib/captcha';
import { getRuntimeRecaptchaSiteKey } from './shared';

export function generateCaptchaTokenResult() {
	// Always use the runtime site key (window stash) for BOTH loading and executing, so a single prod
	// artifact works per-environment and the render/execute keys can never diverge. The base impl
	// self-loads api.js and waits for it to be ready, so callers here work without a mounted form
	// (the donate flow) — the source of "[WARN] Google Recaptcha not loaded" (TEC-3418).
	return _generateCaptchaTokenResult(getRuntimeRecaptchaSiteKey());
}
